const Form029TC = {
    stepName: {
        statement: "重要提示",
        applicationTeacherInformation: "申請表格",
        confirmation: "確認頁",
    },
    label1: {
        header: {
            headerOne: "填寫申請表格須知",
        },
        contentOption: {
            t1: "申請人可親身或以郵寄╱傳真方式遞交已填妥的申請表，教育局會以郵寄方式回覆申請人。收件地址如下：",
            t2: "申請人向教育局提交查核教師註册資料的申請前，須安排有關教師填寫本表格第II部，證明已事先取得該教師的同意。申請人須確保已填妥本表格第I、II及IV部。",
            t3: "教育局可要求申請人及／或有關教師提供進一步資料，以核實本表格第 I、II及IV部所載的資料。",
        },
        serialOption: {
            t1: "(1)",
            t2: "(2)",
            t3: "(3)",
        },
        t1Option: {
            o1: "九龍協調道3號",
            o2: "工業貿易大樓2樓",
            o3: "教育局教師註冊小組",
            o4: "電話：3467 8282&emsp;&emsp;傳真：2520 0065",
            // o5: "傳真：2520 0065",
            o6: "（辦公時間：星期一至五上午八時三十分至下午一時及下午二時至六時星期六、日及公眾假期休息）",
        },
        t7Option: {
            o7: "九龍協調道3號",
            o8: "工業貿易大樓2樓",
            o9: "教育局教師註冊小組",
            o10: "（電話：3467 8282）",
        },

        statementOne: "本人已閱讀、明白及同意上述條款及細則。",
        statementTwo:
            "本人理解申請人和教師需要擁有「智方便+」帳戶才能處理申請。",
    },
    label: {
        ImportantNotesContent: {
            title: "個人資料收集聲明",
            p_title: "收集個人資料的目的",
            p1_1: "你在本表格提供的個人資料，會供教育局用於以下一項或多項用途：",
            p1_a: "處理、核實及查證就發放教師註冊資料的申請；",
            p1_b: "就上文(a)項所述申請的處理、核實及查證，將個人資料與政府相關政策局／部門資料庫進行核對；",
            p1_c: "將個人資料與教育局資料庫進行核對，以核實／更新教育局的記錄；",
            p1_d: "培訓及發展，包括發出計劃／活動邀請、處理發還課程費用申請、 評審提名、獎項和獎學金，以及監察達標進度；",
            p1_e: "處理及審核撥款／補助／津貼申請、發放撥款／補助／津貼，以及審計；",
            p1_f: "編製統計資料、研究及政府刊物；以及",
            p1_g: "執行規則及規例[包括《教育條例》(香港法例第279章)及其附屬法例(例如《教育規例》、《補助學校公積金規則》、《津貼學校公積金規則》)和《資助則例》 )]。",

            p2: "你必須按本表格的要求及於本局處理本表格的過程中提供個人資料。假如你沒有提供該等個人資料，本局可能無法辦理或繼續處理申請。",

            p_title3: "可獲轉移資料者",
            p3_1: "你提供的個人資料會供教育局人員取閱。除此之外，本局亦可能會向下列各方或在下述情況轉移或披露該等個人資料：",
            p3_a: "政府其他政策局及部門，以用於上文第1段所述的用途；",
            p3_b: "與本表格相關的學校，以用於上文第1段所述的用途；",
            p3_c: "你曾就披露個人資料給予訂明同意；以及；",
            p3_d: "根據適用於香港的法例或法庭命令授權或規定披露個人資料。",

            p_title4: "查閱個人資料",
            p4: "你有權要求查閱及更正教育局所持有關於你的個人資料。如需查閱或更正個人資料，請以書面向教師註冊小組提出(地址：九龍協調道3號工業貿易大樓2樓)。",
            // p5: "如欲查詢有關本表格所蒐集的個人資料，包括要求查閱及改正資料事宜，需以書面方式向教育局提出。",
        },
        header: {
            headerOne: "第I部（由申請發放教師註冊資料的人士填寫）",
            headerTwo: "第II部（由授權教育局發放教師註冊資料的教師填寫）",
            headerThree: "第III部（由教育局填寫）",
            headerFour: "第IV部（由申請發放教師註冊資料的人士填寫）",
        },
        titleOption: {
            Mr: "先生",
            Ms: "女士",
        },
        sex: {
            male: "男",
            female: "女",
        },
        title: "先生／女士",
        englishName: "英文姓名",
        chineseName: "本人",
        chineseName2: "中文名字",
        IDNumber: "香港身份證號碼",
        applicantContactNo: "申請人聯絡電話",
        nameOfApplicant: "申請人姓名",
        teacherRegistrationNo: "教員註冊證號碼",
        teachersContactNo: "教師聯絡電話",
        nameOfTeacher: "教師姓名",
        date: "日期",

        applicantName: "申請人姓名",
        applicantAddress: "申請人地址",
        emailAddress: "教師的電郵地址",
        tips: "申請人向教育局提交此申請表前，須安排有關教師填寫本表格第II部，請填上相關教師的電郵地址。",
    },
    label2: {
        l1: "本人",
        l2: "(英文姓名︰",
        l3: ")，香港身份證號碼︰",
        l4: "，申請發放第II部所述教師於第III部所列的教師註冊資料。",
        l5: "本人謹此聲明，本表格第I部所提供的資料均屬真實及詳盡。本人已閱讀本申請表格全部內容，並明白「填寫申請表格須知」。",
        l6: ")",
        l7: "，香港身份證號碼︰",
    },
    label3: {
        l1: "本人",
        l2: "(英文姓名︰",
        l3: ")，教員註冊證號碼︰",
        l4: "，授權教育局向第I部所述人士發放下文第III部所列本人在《教育條例》(第279章)下的教師註冊資料。",
        l5: "本人謹此聲明，本表格第II部所提供的資料均屬真實及詳盡。本人已閱讀本申請表格全部內容，並明白「填寫申請表格須知」。",
        l6: ")",
        l7: "，教員註冊證號碼︰",
    },
    errorMsg: {
        required: "此字段必填",
        requiredTrue: "請輸入正確的字段 ",
        IDNumber: "請輸入正確的身份證號碼",
        enName: "請輸入正確的英文名稱",
        scName: "請輸入正確的中文名稱",
        email: "請輸入正確的電郵地址",
        length: {
            note1: "長度不得超過20個字符",
            note2: "長度不得超過30個字符",
            note3: "長度不得超過50個字符",
            note4: "長度不得超過70個字符",
            note5: "長度不得超過100個字符",
            note6: "長度不得超過1000個字符",
            note7: "請輸入長度不超過15位的字母／數字",
        },
        tel: {
            digit: "需要是8-15位",
            rule: "需要匹配電話號碼規則",
            faxRule: "需要匹配傳真號碼規則",
        },
        date: {
            rule: "請輸入有效日期",
            todayOrBefore: "請選擇今天或之前",
            afterThisDate: "請在之後選擇日期{{targetDate}}",
            age: "申請人在提交時至少年滿18歲。",
        },
        tips: "請輸入正確格式的內容 ",
        upload: "至少上傳一個文件！",
        uploadMax: "最多上傳一個文件！",
        uploadMax5: "最多上傳五個文件！",
    },
    part3: {
        label1: "________ 先生／女士*︰",
        label2: "根據本局的記錄，以上教師的教師註冊資料如下︰",
        option: {
            option1: "本局並無以上教師的教師註冊記錄。",
            option2: "以上教師現為檢定教員。",
            option3: "以上教師現為准用教員。",
            option4:
                "以上教師由 ________ 至 ________ 期間為檢定教員，但自 ________ 起已不再是檢定教員。",
            option5:
                "以上教師由 ________ 至 ________ 期間為准用教員，但自 ________ 起已不再是准用教員。",
            option5b:
                "（如有關准用教員停止受僱於其准用教員許可證所指明的學校，該許可證須當作已經取消。）",
            option6:
                "由於有關教師沒有填妥本表格第II部，故本局未能處理這項申請。",
        },
        label3: "如有查詢，請致電3467 8282與教育局教師註冊小組聯絡。",
    },
    submittedDialog: {
        text1: "你已成功送出表格。請注意表格尚未提交至教育局。表格正在等待教師填妥表格第 II 部。",
        text2: "相關電郵已發送至你的註冊電郵。",
        multiLayerSubmitMsg: "你將會轉到填寫表格的頁面。",
    },
};
export default Form029TC;
